module.exports = __webpack_public_path__ + "static/media/01GalleryPuppets.37513d65.jpeg";